/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from 'react'
import { useRequest } from 'ahooks'
import '@kiss/styles/global.css'
import {
  getLocationVars,
  getRandomStr,
  getUA,
  getCookie,
  throttle
} from '@/utils/utils'

import {
  eventGet,
  scrollProgress,
  booksAdvClickHandle,
  toAppLink,
  getDomainConfig
} from '@kiss/utils/booksAdvUtils'
import {
  getDrainageDataByID,
  reportAdInfo,
  getIp
} from '@/projects/kiss/services/advH5'
import './App.scss'
import LogoPNG from './assets/logo.png'
import Loading from './component/Loading'
import debounce from 'lodash/debounce'
import webview from '@/utils/web-view'
import { i18n } from '../../utils/locales'
import { PROJECT_NAME } from '../../constant'
import { MF_LOGO } from '../../constant/logo'

const App: React.FC = () => {
  // id - 表示后台配置的引流H5对应的id
  // mode - 1-静态按钮 2-动态按钮 4-静态按钮(一次询问) 5-动态按钮（一次询问）
  // mediaType - 引流媒体 （rs-reelshort）
  const { id, mode = '1', mediaType = '' }: any = getLocationVars()
  /** 对应域名的配置信息 */
  const domainConfig = getDomainConfig()
  const { ios, android } = getUA()
  const timeRef = React.useRef<any>()
  /** 存同步获取字段 */
  const dataRef = React.useRef<any>()
  const initialUid = getRandomStr(12)
  /** 自研匹配信息 */
  const matchingFieldRef = React.useRef<any>()
  /** 落地页uid */
  const uidNum =
    localStorage?.getItem('uidNum') || initialUid + new Date().getTime()
  localStorage.setItem('uidNum', `${uidNum}`)
  const {
    loading,
    data: bookData,
    error
  } = useRequest(() => getDrainageDataByID(id, { web_uid: uidNum }), {})
  const { run: getIpHandle } = useRequest(() => getIp(), {
    manual: true,
    onSuccess: (res) => {
      if (res.code === 0) {
        const ip = res.data.ip

        const serverIp = localStorage.getItem('serverIp') || '_'
        const arr = serverIp.split('_')
        if (Number(arr[1]) < new Date().getTime()) {
          clearInterval(timeRef.current)
        }
        if (ip && arr[0] && ip !== arr[0]) {
          reportHandl({
            ...matchingFieldRef.current,
            lastIp: arr[0]
          })
        }
      }
    }
  })
  // 上传广告信息， ios备用方案 isIp-ip改变时候调用
  const { run: reportHandl, params } = useRequest(
    (data) => reportAdInfo(data),
    {
      manual: true,
      onSuccess: (res) => {
        console.log(
          '%c [ params ]-82',
          'font-size:13px; background:pink; color:#bf2c9f;',
          params
        )
        if (res.code === 0) {
          // 存下当前ip
          localStorage.setItem(
            'serverIp',
            res.data.ip + '_' + (new Date().getTime() + 60 * 60 * 1000)
          )
          if (timeRef.current) {
            clearInterval(timeRef.current)
          }
          timeRef.current = setInterval(() => {
            getIpHandle()
          }, 3000)
        }
      }
    }
  )

  // 存放剪切板数据
  const urlQueryParams = {
    bookId: bookData?.data?.book_id || '6290a3bf31c0b36b824d6861',
    // 不指定章节 - 0 | 指定章节 - 具体章节id
    chapterId: bookData?.data?.next_chapter_id || 4,
    uid: uidNum,
    scheme: 'cmskiss',
    // 与客户端约定好，该变量用于判断当前唤起app是通过H5中的剪切板和schemeURL
    isFromH5: 2,
    // 1-app跳转大厅，2-app跳转阅读器
    pushType: 2,
    // 内容类型 1-书籍；6-视频
    contentType: Number(bookData?.data?.contentType || 1),
    // 回到大厅跳转类型 0-默认大厅首个tab 1-根据书籍类型跳转对应大厅tab(小说跳小说tab，视频跳短剧tab) 2-for you 90-根据后端下发
    returnType: Number(bookData?.data?.returnType || 0),
    channelId: mediaType,
    href: `${window.location.href}${
      bookData?.data?.son_id ? `&sonid=${bookData?.data?.son_id}` : ''
    }`
  }

  // 上报数据
  const appflyersParms = () => {
    // 进行AB测的子id
    const sonId = bookData?.data?.son_id
    const urlSuffix = sonId ? `&sonid=${sonId}` : ''
    const newUrl = location.href + urlSuffix

    const parms9 = getLocationVars()
    parms9._fbc = getCookie('_fbc')
    parms9._fbp = getCookie('_fbp')
    parms9.pixel_id = domainConfig.pixel
    /** 如果有进行ab测，上报的链接拼接上ab测子id */
    parms9.url = newUrl
    parms9.rs_uuid = dataRef.current?.uid || ''
    parms9.referred = document.referrer
    return parms9
  }

  /** 页面滑动进度防抖上报 */
  const debouncedEventGet = debounce((progress) => {
    eventGet({
      parm1: 4,
      parm4: progress,
      parm6: String(bookData?.data?.next_chapter_id || 4),
      parm7: urlQueryParams.bookId,
      parm8: urlQueryParams.uid,
      parm9: JSON.stringify(appflyersParms()),
      parm10: `${bookData?.data?.channel_id}#${id}`
    })
  }, 200)

  const onScroll = () => {
    const progress = scrollProgress()
    if ([15, 30, 45, 60, 75, 90, 100].includes(progress)) {
      // 页面滑动进度上报
      debouncedEventGet(progress)
    }
  }
  // console.log('🚀 ~ file: App.tsx ~ line 67 ~ appflyersParms', appflyersParms)
  useEffect(() => {
    // 页面一打开就上报
    eventGet({
      parm1: 3,
      parm8: urlQueryParams.uid,
      parm9: JSON.stringify(appflyersParms())
    })
    if (mediaType === 'rs') {
      webview.exec('getUserInfo', {
        callback: (res) => {
          dataRef.current = {
            uid: res.uid
          }
        }
      })
    } else if (mediaType === 'tt') {
      // @ts-ignore
      ttq.load(domainConfig.pixel)
      // @ts-ignore
      ttq.page()
    } else {
      // FB像素追踪上报
      // @ts-ignore
      fbq('init', domainConfig.pixel)
      // @ts-ignore
      fbq('track', 'PageView')
      document!.querySelector(
        'noscript'
      )!.innerHTML = `https://www.facebook.com/tr?id=${domainConfig.pixel}&ev=PageView&noscript=1`
    }
  }, [])

  useEffect(() => {
    if (bookData?.data?.channel_id) {
      // 页面曝光上报
      eventGet({
        parm1: 1,
        parm6: String(bookData?.data?.next_chapter_id || 4),
        parm7: urlQueryParams.bookId,
        parm8: urlQueryParams.uid,
        parm9: JSON.stringify(appflyersParms()),
        parm10: `${bookData?.data?.channel_id}#${id}`
      })
      window.addEventListener('scroll', onScroll)
    }

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [bookData?.data?.channel_id])

  if (loading)
    return (
      <Loading
        title='loading'
        style={{
          fontSize: 30,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}
      />
    )

  if (!id) return <div className='error-tip'>Missing required parameters</div>

  if (error)
    return (
      <div className='error-tip'>An error has occurred, please try again</div>
    )

  if (!bookData?.data?.book_id)
    return <div className='error-tip'>The page is invalid.</div>

  if (bookData?.code !== 0)
    return <div className='error-tip'>{JSON.stringify(bookData?.msg)}</div>

  /** 按钮点击事件 */
  const clickHandle = throttle(
    () => {
      matchingFieldRef.current = booksAdvClickHandle({
        urlQueryParams,
        uidNum
      })
      // 点击跳转上报
      eventGet({
        parm1: 2,
        parm4: scrollProgress(),
        parm6: String(bookData?.data?.next_chapter_id || 4),
        parm7: urlQueryParams.bookId,
        parm8: urlQueryParams.uid,
        parm9: JSON.stringify(appflyersParms()),
        parm10: `${bookData?.data?.channel_id}#${id}`
      })
      // 自研匹配上报
      reportHandl(matchingFieldRef.current)
      toAppLink({ urlQueryParams })
    },
    3000,
    true
  )

  return (
    <div className='page-ctr'>
      {bookData?.data?.title ? (
        <div className='book-title'>{bookData?.data?.title}</div>
      ) : null}
      <div className='book-recommened'>{bookData?.data?.recommend}</div>
      <div className='book-cover'>
        <img src={bookData?.data?.cover} alt='' className='book-img' />
        <div className='logo-container'>
          <img src={MF_LOGO} alt='' className='logo-img' />
          <span>{PROJECT_NAME}</span>
        </div>
      </div>
      <div className='summary-ctr'>
        {bookData?.data?.chapters.map(
          (
            { title, content }: { title: string; content: Array<string> },
            idx: number
          ) => {
            if (content?.length > 0) {
              return (
                <div key={`chapter_${idx}`} className='summary-content'>
                  {title?.length > 0 && (
                    <div>
                      <p className='chapter_title'>
                        {title.replace(/\s/g, ' ')}
                      </p>
                    </div>
                  )}
                  {content?.map((item: string, index: number) => {
                    if (
                      !item ||
                      item.replace('&nbsp;', '')?.trim()?.length === 0
                    )
                      return null
                    return (
                      <div
                        key={`chapter_${idx}_${index}`}
                        dangerouslySetInnerHTML={{
                          __html: `<p>${item.replace(/\s/g, ' ')}</p>`
                        }}
                      ></div>
                    )
                  })}
                </div>
              )
            }
            return null
          }
        )}
      </div>
      <div className='click_to_read' onClick={clickHandle}>
        {i18n('CLICK_TO_READ')}
      </div>

      {['2', '5'].includes(mode) ? (
        <div className='evoke_content evoke_content_animation'>
          <div className='evoke_btn evoke_btn_animation' onClick={clickHandle}>
            <div className='finger'></div>
            {i18n('CONTINUE_READING')}
          </div>
        </div>
      ) : (
        <div
          className={`evoke_content ${
            ios && mediaType === 'rs' ? 'evoke_content_ios' : ''
          }`}
        >
          <div className='evoke_btn' onClick={clickHandle}>
            {i18n('CONTINUE_READING')}
          </div>
        </div>
      )}
      {/* <ToKissFooter
        kissLinkData={urlQueryParams}
        appIcon={''}
        customParamsDic={{ parm1: 'bookId' }}
      ></ToKissFooter> */}
    </div>
  )
}

export default App
